// libraries
import React from "react";
import { render } from "react-dom";

// app file importing
import App from "./App";

// style sheets
import "./style/main.css";
import "./style/desktop.css";
import "./style/square.css";
import "./style/mobile.css";
import "./style/print.css";

// init
render(<App />, document.getElementById("root"));
